import {serverConfigFromHtmlInstance} from "../ServerConfigFromHtml/ServerConfigFromHtml";

interface WebSocketConnectionOptions {
    // подписка на опрееделные каналы
    // из массива
   channels: string[];
    // объект с query-параметрами, например { clientKey: 'abc' }
    queryParams?: Record<string, any>;
    // коллбэк на получение сообщений
    onMessage?: (event: MessageEvent) => void;
    onError?: (event: Event) => void;
    onClose?: (event: CloseEvent) => void;
    onOpen?: (event: Event) => void;
}

/**
 * Создает универсальное WebSocket-соединение с учетом окружения и параметров.
 */
export function WebSocketConnector({
    // endpoint вебсокет сервера
    channels = [],
    queryParams = {},
    onMessage,
    onError,
    onClose,
    onOpen
}: WebSocketConnectionOptions): WebSocket {
    // контролллер на ws сервере
    const wsController = '/ws';
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const hostname = window.location.hostname;
    const port = serverConfigFromHtmlInstance.config['webSocketPort'] ?? 8101;

    const fullParams = {
        channels: channels.join(','),
        ...queryParams,
    };

    const queryString = Object.entries(fullParams)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    const fullUrl = `${protocol}://${hostname}:${port}${wsController}${queryString ? '?' + queryString : ''}`;

    const socket = new WebSocket(fullUrl);

    socket.onerror = (err) => {
        console.error("WebSocket error:", err);
    };

    socket.onmessage = onMessage ?? ((event) => {
        console.log("WebSocket message:", event.data);
    });

    socket.onerror = onError ?? ((err) => {
        console.error("WebSocket error:", err);
    });
    socket.onclose = onClose ?? (() => {
        console.warn("WebSocket соединение закрыто.");
    });
    socket.onopen = onOpen ?? (() => {
        console.warn("WebSocket соединение установлено.");
    });

    return socket;
}